import { useState } from 'react';

import FormTitle from 'components/PageLayout/FormTitle';
import TermsPopUp from 'components/TermsPopUp';
import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import Typography from 'components/curo-components/common/Typography';
import Checkbox from 'components/digifi-wrappers/Checkbox';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { saveTermsOfUseAcceptance } from 'thunks';

import styles from './AcceptLegalDocumentsStep.module.scss';

const PAGE_TITLE = 'Last step!';

interface IAcceptLegalDocumentsStepProps {
  onStepComplete: () => void;
}

const AcceptLegalDocumentsStep = ({ onStepComplete }: IAcceptLegalDocumentsStepProps) => {
  const application = useAppSelector(getApplicationSelector);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const isButtonDisabled = !isChecked;

  const handleContinue = async () => {
    if (application) {
      await dispatchWithUnwrap(saveTermsOfUseAcceptance({ applicationId: application.id }));
      onStepComplete();
    }
  };

  return (
    <>
      <FormTitle title={PAGE_TITLE} />
      <div className={styles.pageContainer}>
        <Typography className={styles.regularText}>
          We need your permission to keep going.
        </Typography>
        <Typography className={styles.regularText}>
          By clicking “Check for Pre-qualification”, I authorize Heights Finance to obtain my credit
          report to check my eligibility for pre-qualified offers. This results in a “soft” credit
          inquiry, which does not affect my credit score*.
        </Typography>
        <Checkbox
          onClick={() => {
            if (isChecked) {
              setIsChecked(false);
              return;
            }
            setIsModalOpen(true);
          }}
          checked={isChecked}
          name="creditServicesAgreement"
          label={
            <span>
              I agree to <span className={styles.underline}>eConsent Terms and Conditions</span>
            </span>
          }
        />
        {isModalOpen && (
          <TermsPopUp
            onClose={() => setIsModalOpen(false)}
            onAgreeClick={() => {
              setIsChecked(true);
              setIsModalOpen(false);
            }}
          />
        )}
        <div className={styles.textWrapper}>
          <div className={styles.smallText}>*</div>
          <p className={styles.smallText}>
            To see if you pre-qualify, Heights Finance will conduct a "soft" credit inquiry to
            determine eligibility. This inquiry does not impact your credit score. If you decide to
            move forward with applying for a loan, Heights Finance will order a credit report using
            a "hard" credit inquiry. A hard inquiry may impact your credit score.
          </p>
        </div>
        <ButtonWithLoadingState
          disabled={isButtonDisabled}
          kind="primary"
          size="form"
          onClick={handleContinue}
          className={styles.button}
        >
          Check for Pre-qualification
        </ButtonWithLoadingState>
      </div>
    </>
  );
};

export default AcceptLegalDocumentsStep;
